module.exports = __webpack_public_path__ + "static/media/n_icon_header_bg@2x.951c1c26.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_header_bg@2x.png
// module id = 669
// module chunks = 0 1